<template>
  <div>
    <div>
      <v-row dense v-if="isCliente == 0">
        <v-col cols="9" sm="4" md="4">
          <v-text-field
            v-model="camposBD.guia_interna"
            label="Numero de Guía"
            persistent-hint
            :disabled="!enableNumGuia"
            append-icon="file_open"
            v-if="camposBD.tipoguia != 'importacion'"
          />
        </v-col>
        <v-col cols="3" sm="2" md="2">
          <v-checkbox
          v-model="enableNumGuia"
          label="Habilitar"
          @change="handleEnableNumGuia()"
          v-if="!editando && camposBD.tipoguia != 'importacion'"
        />
        </v-col>
        <v-col cols="3" sm="2" md="2">
          <v-checkbox
          v-model="asignarCliente"
          label="Asignar a cliente"
          @change="handleAsignarCliente()"
          v-if="!editando"
        />
        </v-col>
        <v-col cols="9" sm="4" md="4">
          <v-combobox
            v-model="cliente"
            :items="clientes"
            item-text="name"
            item-value="id"
            label="Cliente"
            append-icon="mdi-handshake"
            return-object
            v-if="asignarCliente"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-tabs v-model="tab">
          <v-tab ripple href="#tab-1">
            <v-icon>mdi-airplane-takeoff</v-icon>- Remitente / Consignatario
          </v-tab>
          <v-tab v-show="remConValidos" ripple href="#tab-2">
            <v-icon>mdi-truck-delivery</v-icon>- Información de Envío
          </v-tab>
          <v-tab
            v-show="infoEnvValidos"
            ripple
            href="#tab-3"
          >
            <v-icon>mdi-cube-send</v-icon>- Información de Paquete
          </v-tab>
          <v-tab
            v-show="
              (
                facturaPropia.opcion == 'Crear' && infoPaquetesValidos &&
                !boolDocumentos)
            "
            ripple
            href="#tab-4"
          >
            <v-icon>mdi-file-document</v-icon>- Detalle de Factura
          </v-tab>
          <!--v-tab
            v-if="isCliente == 0"
            v-show="
              (
                codtipoguia == 'E' &&
                facturaPropia.opcion == 'Crear' &&
                !boolDocumentos) ||
              (boolDocumentos &&
                codtipoguia == 'E' &&
                facturaPropia.opcion == 'Crear')
            "
            ripple
            href="#tab-5"
          >
            <v-icon>mdi-file-document</v-icon>- Información Adicional Factura
          </v-tab-->
          <v-tab-item value="tab-1">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-card>
                  <v-card-text>
                    <v-form
                      ref="formRemCon"
                      v-model="validRemCon"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-card elevation="1" outlined>
                            <v-card-title>
                              Sender ({{ camposBD.tipoguia }})
                            </v-card-title>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" sm="12" md="7">
                                  <!--v-combobox
                                    v-model="dirRemitente"
                                    :items="direcciones"
                                    item-text="referencia"
                                    item-value="id"
                                    label="Referencia"
                                    append-icon="check_circle"
                                    return-object
                                    clearable
                                    :disabled="camposBD.tipoguia != 'importacion' && chkDatosCliente"
                                    @change="popularRemitente(dirRemitente)"
                                  /-->
                                  <v-autocomplete
                                    v-model="dirRemitente"
                                    :items="direccionesR"
                                    :search-input.sync="searchR"
                                    item-text="referencia"
                                    item-value="id"
                                    label="Referencia"
                                    append-icon="check_circle"
                                    return-object
                                    clearable
                                    :disabled="camposBD.tipoguia != 'importacion' && chkDatosCliente"
                                    @change="popularRemitente(dirRemitente)"
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="5">
                                  <v-checkbox v-if="camposBD.tipoguia != 'importacion'" v-model="chkDatosCliente" @change="handleChkDatosCliente()" label="Deseo utilizar mis datos de cliente"></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.contacto_e"
                                    label="Contacto"
                                    required
                                    :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="person"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.empresa_e"
                                    label="Empresa"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="domain"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.telefono_e"
                                    label="Teléfono"
                                    required
                                    :rules="[reglas.requeridoTxt, reglas.largo(25)]"
                                    :counter="25"
                                    append-icon="settings_phone"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.nit_e"
                                    label="NIT / RUC"
                                    :rules="[reglas.largo(20)]"
                                    :counter="20"
                                    append-icon="card_travel"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.direccion1_e"
                                    label="Dirección 1"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="assistant_direction"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.direccion2_e"
                                    label="Dirección 2"
                                    required
                                    :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="assistant_direction"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.direccion3_e"
                                    label="Dirección 3"
                                    :rules="[reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="assistant_direction"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    ref="correo"
                                    v-model="camposBD.correo_e"
                                    label="Correo"
                                    required
                                    :rules="[reglas.requeridoTxt, reglas.largo(300)]"
                                    :counter="300"
                                    append-icon="mail"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-model="paisRemitente"
                                    :items="paises"
                                    item-text="nombre"
                                    item-value="iso"
                                    label="País"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="map"
                                    return-object
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-if="camposBD.pais_e == 'US'"
                                    v-model="estadoRemitente"
                                    :items="estados"
                                    item-text="nombre"
                                    item-value="abbr"
                                    label="Estado"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="pin_drop"
                                    return-object
                                  />
                                  <v-text-field
                                    v-if="camposBD.pais_e != 'US' && camposBD.pais_e != 'EC'"
                                    v-model="camposBD.estado_e"
                                    label="Estado / Departamento"
                                    :rules="[reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="pin_drop"
                                  />
                                  <v-combobox
                                    v-model="provincia_e"
                                    :items="provincias"
                                    item-text="provincia"
                                    item-value="provincia"
                                    label="Provincia"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="pin_drop"
                                    return-object
                                    v-if="camposBD.pais_e == 'EC'"
                                  ></v-combobox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-model="ciudad_e"
                                    :items="ciudadesE"
                                    item-text="ciudad"
                                    item-value="ciudad"
                                    label="Ciudad"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="pin_drop"
                                    return-object
                                    v-if="camposBD.pais_e == 'EC'"
                                  ></v-combobox>
                                  <v-text-field
                                    v-model="camposBD.ciudad_e"
                                    label="Ciudad"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="place"
                                    v-if="camposBD.pais_e != 'EC'"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.zip_e"
                                    :rules="[reglas.largo(12)]"
                                    :counter="12"
                                    label="Codigo Postal"
                                    append-icon="near_me"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="6">
                                  <v-checkbox
                                  v-model="chkCrearRemitente"
                                  :label="dirRemitente != null ? 'Deseo ACTUALIZAR este contacto en mi libreta' : 'Deseo GUARDAR este contacto en mi libreta'"
                                  v-if="!chkDatosCliente"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                  v-model="referenciaRemCrear"
                                  label="Referencia"
                                  append-icon="check_circle"
                                  v-if="chkCrearRemitente && dirRemitente == null && !chkDatosCliente"
                                  :rules="dirRemitente != null? [reglas.largo(50)] : [reglas.requeridoTxt, reglas.largo(50)]"
                                  :counter="50"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-card elevation="1" outlined>
                            <v-card-title>
                              Receiver ({{ camposBD.tipoguia }})
                            </v-card-title>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" sm="12" md="7">
                                  <!--v-combobox
                                    v-model="dirConsignatario"
                                    :items="direcciones"
                                    item-text="referencia"
                                    item-value="id"
                                    label="Referencia"
                                    append-icon="check_circle"
                                    return-object
                                    clearable
                                    @change="
                                      popularConsignatario(dirConsignatario)
                                    "
                                  /-->
                                  <v-autocomplete
                                    v-model="dirConsignatario"
                                    :items="direccionesC"
                                    :search-input.sync="searchC"
                                    item-text="referencia"
                                    item-value="id"
                                    label="Referencia"
                                    append-icon="check_circle"
                                    return-object
                                    clearable
                                    :disabled="camposBD.tipoguia == 'importacion' && chkDatosClienteI"
                                    @change="popularConsignatario(dirConsignatario)"
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="5">
                                  <v-checkbox  v-if="camposBD.tipoguia == 'importacion'" v-model="chkDatosClienteI" @change="handleChkDatosClienteI()" label="Deseo utilizar mis datos de cliente"></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.contacto_c"
                                    label="Contacto"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="person"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.empresa_c"
                                    label="Empresa"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="domain"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.telefono_c"
                                    label="Teléfono"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(25)]"
                                    :counter="25"
                                    append-icon="settings_phone"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.nit_c"
                                    label="NIT / RUC"
                                    :rules="[reglas.largo(20)]"
                                    :counter="20"
                                    append-icon="card_travel"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.direccion1_c"
                                    label="Dirección 1"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="assistant_direction"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.direccion2_c"
                                    label="Dirección 2"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="assistant_direction"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.direccion3_c"
                                    label="Dirección 3"
                                    append-icon="assistant_direction"
                                    :rules="[reglas.largo(35)]"
                                    :counter="35"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    ref="correo"
                                    v-model="camposBD.correo_c"
                                    label="Correo"
                                    required
                                    :rules="[reglas.requeridoTxt, reglas.largo(300)]"
                                    :counter="300"
                                    append-icon="mail"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-model="paisConsignatario"
                                    :items="paises"
                                    item-text="nombre"
                                    item-value="iso"
                                    label="País"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="map"
                                    return-object
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-if="camposBD.pais_c == 'US'"
                                    v-model="estadoConsignatario"
                                    :items="estados"
                                    item-text="nombre"
                                    item-value="abbr"
                                    label="Estado"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="pin_drop"
                                    return-object
                                  />
                                  <v-text-field
                                    v-if="camposBD.pais_c != 'US' && camposBD.pais_c != 'EC'"
                                    v-model="camposBD.estado_c"
                                    label="Estado / Departamento"
                                    :rules="[reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="pin_drop"
                                  />
                                  <v-combobox
                                    v-model="provincia_c"
                                    :items="provincias"
                                    item-text="provincia"
                                    item-value="provincia"
                                    label="Provincia"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="pin_drop"
                                    return-object
                                    v-if="camposBD.pais_c == 'EC'"
                                  ></v-combobox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-model="ciudad_c"
                                    :items="ciudadesC"
                                    item-text="ciudad"
                                    item-value="ciudad"
                                    label="Ciudad"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="pin_drop"
                                    return-object
                                    v-if="camposBD.pais_c == 'EC'"
                                  ></v-combobox>
                                  <v-text-field
                                    v-model="camposBD.ciudad_c"
                                    label="Ciudad"
                                    required
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                    append-icon="place"
                                    v-if="camposBD.pais_c != 'EC'"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="camposBD.zip_c"
                                    label="Codigo Postal"
                                    append-icon="near_me"
                                    :rules="[reglas.largo(12)]"
                                    :counter="12"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="6">
                                  <v-checkbox
                                  v-model="chkCrearConsignatario"
                                  :label="dirConsignatario != null ? 'Deseo ACTUALIZAR este contacto en mi libreta' : 'Deseo GUARDAR este contacto en mi libreta'"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                  v-model="referenciaConCrear"
                                  label="Referencia"
                                  append-icon="check_circle"
                                  v-if="chkCrearConsignatario && dirConsignatario == null"
                                  :rules="dirConsignatario != null? [reglas.largo(50)] : [reglas.requeridoTxt, reglas.largo(50)]"
                                  :counter="50"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      outlined
                      color="primary darken-1"
                      @click="validarRemCon()"
                    >
                      Siguiente
                      <v-icon dark> mdi-arrow-right-thick </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-card>
                  <v-card-text>
                    <v-form
                      ref="formInfoEnv"
                      v-model="validInfoEnv"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-card elevation="24" outlined shaped>
                            <v-card-title>
                              Información de Envío ({{ camposBD.tipoguia }})
                            </v-card-title>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-combobox
                                    v-model="tipo"
                                    :items="tipos"
                                    item-text="tipo"
                                    item-value="tipo"
                                    label="Tipo"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="checklist"
                                    return-object
                                    @change="changeTipo()"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="8">
                                  <v-text-field
                                    v-model="camposBD.descripcion"
                                    label="Descripción"
                                    required
                                    :rules="[reglas.requeridoTxt, reglas.largo(90)]"
                                    :counter="90"
                                    append-icon="mode_edit"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-if="!boolDocumentos"
                                    v-model="camposBD.valor"
                                    label="Valor"
                                    required
                                    type="number"
                                    :rules="[reglas.requeridoTxt]"
                                    append-icon="money"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-combobox
                                    v-if="!boolDocumentos"
                                    v-model="moneda"
                                    :items="monedas"
                                    item-text="moneda"
                                    item-value="moneda"
                                    label="Moneda"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="monetization_on"
                                    return-object
                                    :readonly="readOnlyPorExport"
                                  />
                                </v-col>
                              </v-row>
                              <v-row v-if="codtipoguia == 'I'">
                                <v-col cols="12" sm="12" md="8">
                                  <v-combobox
                                    v-model="termino"
                                    :items="terminos"
                                    item-text="text"
                                    item-value="value"
                                    label="Termino"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="receipt_long"
                                    return-object
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-if="!boolDocumentos"
                                    v-model="camposBD.po"
                                    :rules="[reglas.largo(25)]"
                                    :counter="25"
                                    label="PO"
                                    append-icon="receipt"
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="!boolDocumentos && codtipoguia == 'E'"
                              >
                                <v-col cols="12" sm="12" md="4">
                                  <v-combobox
                                    v-model="opDDP"
                                    :items="optsDDP"
                                    item-text="opcion"
                                    item-value="opcion"
                                    label="DDP (Delivery Duties Paid)"
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="receipt_long"
                                    return-object
                                    @change="changeDDP()"
                                  />
                                </v-col>
                                <v-col
                                  v-if="opDDP.opcion == 'Si'"
                                  cols="12"
                                  sm="12"
                                  md="8"
                                >
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-combobox
                                    v-model="servicio"
                                    :items="servicios"
                                    item-text="descripcion"
                                    item-value="servicio"
                                    label="Servicio"
                                    auto-select-first
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="public"
                                    return-object
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="2">
                                  <v-combobox
                                    v-model="seguro"
                                    :items="seguros"
                                    item-text="seguro"
                                    item-value="seguro"
                                    label="Seguro"
                                    auto-select-first
                                    :rules="[reglas.requeridoCbx]"
                                    required
                                    append-icon="lock"
                                    return-object
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="3" v-if="camposBD.seguro == 'SI'">
                                  <v-text-field
                                    v-model="camposBD.seg_valor_contenido"
                                    label="Valor Contenido"
                                    type="number"
                                    append-icon="money"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="3" v-if="camposBD.seguro == 'SI'">
                                  <v-text-field
                                    v-model="camposBD.seg_flete_int"
                                    label="Valor Flete"
                                    type="number"
                                    append-icon="money"
                                  />
                                </v-col>
                              </v-row>
                              <!--v-row v-if="seguro.seguro == 'No'">
                                <v-col cols="0" sm="0" md="4" />
                                <v-col cols="12" sm="12" md="8">
                                  <span>
                                    Al declinar la toma de un seguro individual
                                    por su carga, se entiende que la empresa no
                                    asumirá ninguna responsabilidad ante
                                    posibles demoras, extravíos o daños sobre el
                                    envío, ni se hará responsable por perdidas o
                                    daños colaterales.
                                  </span>
                                </v-col>
                              </v-row-->
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary darken-1" @click="tab = 'tab-1'" outlined>
                      <v-icon dark> mdi-arrow-left-thick </v-icon> Anterior
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      color="primary darken-1"
                      @click="validarInfoEnvio()"
                      outlined
                    >
                      Siguiente
                      <v-icon dark> mdi-arrow-right-thick </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="12" md="3">
                        <v-card elevation="24" outlined shaped>
                          <v-card-title>
                            Información de Paquete ({{ camposBD.tipoguia }})
                          </v-card-title>
                          <v-card-text>
                            <v-form
                              ref="formPaquete"
                              v-model="validPaq"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-model="unidadPesoPaq"
                                    :items="optUnidadPesoPaq"
                                    item-text="unidad_peso"
                                    item-value="descripcion"
                                    label="Unidad Peso"
                                    auto-select-first
                                    append-icon="scale"
                                    return-object
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-combobox
                                    v-model="uMPaq"
                                    :items="optUMPaq"
                                    item-text="unidad_medida"
                                    item-value="descripcion"
                                    label="Unidad Medida"
                                    auto-select-first
                                    append-icon="straighten"
                                    return-object
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    ref="piezaspaquete"
                                    v-model="paquete.piezas"
                                    label="Piezas"
                                    required
                                    type="number"
                                    append-icon="calculate"
                                    step="1"
                                    min="1"
                                    @change="calcularPesoTotalPaquete()"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="paquete.peso"
                                    label="Peso"
                                    type="number"
                                    append-icon="calculate"
                                    step="any"
                                    min="1"
                                    :rules="[
                                      reglas.requeridoTxt,
                                    ]"
                                    @change="calcularPesoTotalPaquete()"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="paquete.pesototal"
                                    label="Peso Total"
                                    type="number"
                                    readonly
                                    disabled
                                    append-icon="calculate"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="paquete.largo"
                                    label="Largo"
                                    type="number"
                                    append-icon="calculate"
                                    step="1"
                                    min="0"
                                    @change="calcularVolumenTotalPaquete()"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="paquete.ancho"
                                    label="Ancho"
                                    type="number"
                                    append-icon="calculate"
                                    step=""
                                    min="0"
                                    @change="calcularVolumenTotalPaquete()"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="paquete.alto"
                                    label="Alto"
                                    type="number"
                                    append-icon="calculate"
                                    step="1"
                                    min="1"
                                    @change="calcularVolumenTotalPaquete()"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="paquete.volumentotal"
                                    label="Volumen Total"
                                    type="number"
                                    readonly
                                    disabled
                                    append-icon="calculate"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-spacer />
                                  <v-btn
                                    color="blue darken-1"
                                    dark
                                    @click="addPaquete(paquete)"
                                    outlined
                                  >
                                    Agregar Paquete
                                    <v-icon dark> mdi-plus </v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="12" md="9">
                        <v-card elevation="24" outlined shaped>
                          <v-card-title>
                            Paquetes ({{ camposBD.tipoguia }})
                          </v-card-title>
                          <v-card-text>
                            <v-data-table
                              :headers="headersPaquetes"
                              :items="paquetes"
                              class="elevation-1"
                            >
                              <template v-slot:item.acciones="{ item }">
                                <v-btn
                                  icon
                                  color="red"
                                  @click="deletePaquete(item)"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer /> Peso Total : {{ camposBD.peso }} /
                            Volumen Total :
                            {{ camposBD.volumen }}
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row justify="end" v-show="false">
                      <v-col cols="12" sm="12" md="4">
                        <v-combobox
                          v-show="codtipoguia != 'N' && !boolDocumentos"
                          v-model="facturaPropia"
                          :items="optFacturaPropia"
                          item-text="opcion"
                          item-value="opcion"
                          label="Ocupara su Propia Factura o desea Crear una?"
                          auto-select-first
                          append-icon="description"
                          return-object
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary darken-1" @click="tab = 'tab-2'" outlined>
                      <v-icon dark> mdi-arrow-left-thick </v-icon> Anterior
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      v-show="(facturaPropia.opcion == 'Crear' && !boolDocumentos && camposBD.tipoguia != 'nacional') ||
                      (facturaPropia.opcion == 'Crear' && !boolDocumentos && camposBD.tipoguia == 'nacional' && camposBD.seguro == 'SI')"
                      color="primary darken-1"
                      @click="validarInfoPaquetes()"
                      outlined
                    >
                      Siguiente
                      <v-icon dark> mdi-arrow-right-thick </v-icon>
                    </v-btn>
                    <v-btn
                      v-show="(facturaPropia.opcion == 'Propia' || boolDocumentos || (camposBD.tipoguia == 'nacional' && camposBD.seguro == 'NO'))"
                      color="blue-grey darken-2"
                      dark
                      @click="saveGuia()"
                    >
                      Guardar <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="tab-4">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-card elevation="24" outlined shaped>
                          <v-card-title>
                            Factura ({{ camposBD.tipoguia }})
                          </v-card-title>
                          <v-card-text>
                            <v-form
                              ref="formItemFac"
                              v-model="validFac"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="6" sm="6" md="4">
                                  <v-text-field
                                    v-model="camposBD.razon_exp"
                                    label="Razón de Exportación"
                                    required
                                    append-icon="mdi-text-box-check"
                                    :rules="[reglas.requeridoTxt,reglas.largo(80)]"
                                    :counter="80"
                                  />
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                  <v-text-field
                                    v-model="camposBD.numfactura"
                                    label="No de Factura"
                                    required
                                    append-icon="description"
                                    :rules="[reglas.requeridoTxt,reglas.largo(35)]"
                                    :counter="35"
                                  />
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                  <v-text-field
                                    v-model="camposBD.lugarincoterms"
                                    label="Lugar Incoterms"
                                    required
                                    append-icon="language"
                                    :rules="[reglas.requeridoTxt,reglas.largo(50)]"
                                    :counter="50"
                                  />
                                </v-col>
                              </v-row>
                              <v-divider />
                              <v-row>
                                <v-col cols="12" sm="12" md="9">
                                  <v-row>
                                    <v-col cols="12" sm="12" md="3">
                                      <v-text-field
                                        ref="descripcionitemfact"
                                        v-model="itemFac.descripcion"
                                        label="Descripción"
                                        required
                                        append-icon="create"
                                        :rules="[reglas.requeridoTxt,reglas.largo(90)]"
                                        :counter="90"
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="2">
                                      <v-combobox
                                        v-model="unidad"
                                        :items="unidades"
                                        item-text="descripcion"
                                        item-value="unidad"
                                        label="Unidad Medida"
                                        append-icon="straighten"
                                        required
                                        :rules="[reglas.requeridoCbx]"
                                        return-object
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="2">
                                      <v-text-field
                                        v-model="itemFac.cantidad"
                                        label="Cantidad"
                                        type="number"
                                        append-icon="calculate"
                                        step="any"
                                        min="1"
                                        :rules="[
                                          reglas.requeridoTxt,
                                        ]"
                                        @change="calcularCostoTotalItem()"
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="2">
                                      <v-text-field
                                        v-model="itemFac.costo"
                                        label="Costo"
                                        type="number"
                                        append-icon="calculate"
                                        step="any"
                                        min="0"
                                        :rules="[
                                          reglas.requeridoTxt,
                                        ]"
                                        @change="calcularCostoTotalItem()"
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="2">
                                      <v-text-field
                                        v-model="itemFac.total"
                                        label="Total"
                                        type="number"
                                        append-icon="calculate"
                                        readonly
                                        disabled
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" sm="12" md="2">
                                      <v-text-field
                                        v-model="itemFac.peso_neto"
                                        label="Peso Neto"
                                        type="number"
                                        append-icon="calculate"
                                        step="any"
                                        min="0"
                                        required
                                        :rules="[
                                          reglas.requeridoTxt,
                                        ]"
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="2">
                                      <v-text-field
                                        v-model="itemFac.peso_bruto"
                                        label="Peso Bruto"
                                        type="number"
                                        append-icon="calculate"
                                        step="any"
                                        min="0"
                                        :rules="[
                                          reglas.requeridoTxt,
                                        ]"
                                        required
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                      <v-combobox
                                        v-model="paisOrigenItem"
                                        :items="paises"
                                        item-text="nombre"
                                        item-value="iso"
                                        label="País de Origen"
                                        append-icon="add_location_alt"
                                        return-object
                                        required
                                        :rules="[reglas.requeridoCbx]"
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                      <v-text-field
                                        v-model="itemFac.arancel"
                                        label="Arancel"
                                        required
                                        :rules="[reglas.largo(18)]"
                                        :counter="18"
                                        append-icon="public"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <!--v-col cols="12" sm="12" md="3">
                                  <v-row>
                                    <v-card>
                                      <v-card-title>
                                        Referencias del Item
                                      </v-card-title>
                                      <v-card-text>
                                        <v-form
                                          ref="formItemReference"
                                          v-model="validItemReference"
                                          lazy-validation
                                        >
                                          <v-row>
                                            <v-col cols="12" sm="12" md="5">
                                              <v-combobox
                                                v-model="referenceType"
                                                :items="referenceTypes"
                                                item-text="nombre"
                                                item-value="codigo"
                                                label="Tipo"
                                                append-icon="file_copy"
                                                return-object
                                                required
                                                :rules="[reglas.requeridoCbx]"
                                              />
                                            </v-col>
                                            <v-col cols="12" sm="12" md="5">
                                              <v-text-field
                                                v-model="itemReference.numero"
                                                label="Número"
                                                required
                                                append-icon="tag"
                                                :rules="[reglas.requeridoTxt]"
                                              />
                                            </v-col>
                                            <v-col cols="12" sm="12" md="2">
                                              <v-btn
                                                fab
                                                dark
                                                small
                                                color="blue darken-1"
                                                @click="
                                                  addItemReference(
                                                    itemReference
                                                  )
                                                "
                                              >
                                                <v-icon> mdi-plus </v-icon>
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-form>
                                        <v-row>
                                          <v-col cols="12" sm="12" md="12">
                                            <v-data-table
                                              :headers="headersItemReferences"
                                              :items="itemFac.detalleref"
                                              class="elevation-1"
                                            >
                                              <template
                                                v-slot:item.acciones="{ item }"
                                              >
                                                <v-btn
                                                  icon
                                                  color="red"
                                                  @click="
                                                    deleteItemReference(item)
                                                  "
                                                >
                                                  <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                              </template>
                                            </v-data-table>
                                          </v-col>
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                  </v-row>
                                </v-col-->
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-spacer />
                                  <v-btn
                                    color="blue darken-1"
                                    dark
                                    @click="addItemFac(itemFac)"
                                    outlined
                                  >
                                    Agregar Item
                                    <v-icon dark> mdi-plus </v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                  :headers="headersItemsFac"
                                  :items="itemsFac"
                                  class="elevation-1"
                                >
                                  <template v-slot:item.acciones="{ item }">
                                    <v-btn
                                      icon
                                      color="red"
                                      @click="deleteItemFac(item)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary darken-1" @click="tab = 'tab-3'" outlined>
                      <v-icon dark> mdi-arrow-left-thick </v-icon> Anterior
                    </v-btn>
                    <v-spacer />
                    <!--v-btn
                      v-if="isCliente == 0"
                      color="primary darken-1"
                      @click="tab = 'tab-5'"
                    >
                      Siguiente
                      <v-icon dark> mdi-arrow-right-thick </v-icon>
                    </v-btn-->
                    <v-btn
                      color="blue-grey darken-2"
                      dark
                      @click="saveGuia()"
                    >
                      Guardar <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!--v-tab-item value="tab-5">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-card>
                  <v-card-title>
                    Información Adicional Factura ({{ camposBD.tipoguia }})
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-card>
                          <v-card-title>
                            Números de Registro (Embarcador)
                          </v-card-title>
                          <v-card-text>
                            <v-form
                              ref="formNumRegE"
                              v-model="validNumRegE"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-combobox
                                    v-model="regNumberE"
                                    :items="registrationNumbers"
                                    item-text="nombre"
                                    item-value="codigo"
                                    label="Tipo"
                                    append-icon="ballot"
                                    return-object
                                    required
                                    :rules="[reglas.requeridoCbx]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                  <v-text-field
                                    v-model="regNumGuiaE.numero"
                                    label="Número"
                                    required
                                    append-icon="tag"
                                    :rules="[reglas.requeridoTxt]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                  <v-combobox
                                    v-model="paisRegNumE"
                                    :items="paises"
                                    item-text="nombre"
                                    item-value="iso"
                                    label="Pais"
                                    append-icon="map"
                                    return-object
                                    required
                                    :rules="[reglas.requeridoCbx]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="2">
                                  <v-btn
                                    fab
                                    dark
                                    small
                                    color="blue darken-1"
                                    @click="addRegNumberE(regNumGuiaE)"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                  :headers="headersRegNumbersE"
                                  :items="regNumbersGuiaE"
                                  class="elevation-1"
                                >
                                  <template v-slot:item.acciones="{ item }">
                                    <v-btn
                                      icon
                                      color="red"
                                      @click="deleteRegNumberE(item)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-card>
                          <v-card-title>
                            Números de Registro (Consignatario)
                          </v-card-title>
                          <v-card-text>
                            <v-form
                              ref="formNumRegC"
                              v-model="validNumRegC"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-combobox
                                    v-model="regNumberC"
                                    :items="registrationNumbers"
                                    item-text="nombre"
                                    item-value="codigo"
                                    label="Tipo"
                                    append-icon="ballot"
                                    return-object
                                    required
                                    :rules="[reglas.requeridoCbx]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                  <v-text-field
                                    v-model="regNumGuiaC.numero"
                                    label="Número"
                                    required
                                    append-icon="tag"
                                    :rules="[reglas.requeridoTxt]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                  <v-combobox
                                    v-model="paisRegNumC"
                                    :items="paises"
                                    item-text="nombre"
                                    item-value="iso"
                                    label="Pais"
                                    append-icon="map"
                                    return-object
                                    required
                                    :rules="[reglas.requeridoCbx]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="2">
                                  <v-btn
                                    fab
                                    dark
                                    small
                                    color="blue darken-1"
                                    @click="addRegNumberC(regNumGuiaC)"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                  :headers="headersRegNumbersC"
                                  :items="regNumbersGuiaC"
                                  class="elevation-1"
                                >
                                  <template v-slot:item.acciones="{ item }">
                                    <v-btn
                                      icon
                                      color="red"
                                      @click="deleteRegNumberC(item)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-card>
                          <v-card-title>Referencias de Factura</v-card-title>
                          <v-card-text>
                            <v-form
                              ref="formInvoiceReference"
                              v-model="validReferenciasFac"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="12" sm="12" md="5">
                                  <v-combobox
                                    v-model="invReferenceType"
                                    :items="invReferenceTypes"
                                    item-text="nombre"
                                    item-value="codigo"
                                    label="Tipo"
                                    append-icon="ballot"
                                    return-object
                                    required
                                    :rules="[reglas.requeridoCbx]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="5">
                                  <v-text-field
                                    v-model="invoiceReference.numero"
                                    label="Número"
                                    required
                                    append-icon="tag"
                                    :rules="[reglas.requeridoTxt]"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="2">
                                  <v-btn
                                    fab
                                    dark
                                    small
                                    color="blue darken-1"
                                    @click="
                                      addInvoiceReference(invoiceReference)
                                    "
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                  :headers="headersInvoiceReferences"
                                  :items="invoiceReferences"
                                  class="elevation-1"
                                >
                                  <template v-slot:item.acciones="{ item }">
                                    <v-btn
                                      icon
                                      color="red"
                                      @click="deleteInvoiceReference(item)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-card>
                          <v-card-title>
                            Información Complementaria
                          </v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col cols="12" sm="12" md="3">
                                <v-text-field
                                  v-model="camposBD.id_exportador"
                                  label="ID Exportador"
                                  append-icon="fingerprint"
                                />
                              </v-col>
                              <v-col cols="12" sm="12" md="3">
                                <v-text-field
                                  v-model="camposBD.cod_exportador"
                                  label="Código Exportador"
                                  append-icon="language"
                                />
                              </v-col>
                              <v-col cols="12" sm="12" md="3">
                                <v-text-field
                                  v-model="camposBD.comentarios_fact"
                                  label="Comentarios Factura"
                                  append-icon="receipt"
                                />
                              </v-col>
                              <v-col cols="12" sm="12" md="3">
                                <v-text-field
                                  v-model="camposBD.instrucciones_fact"
                                  label="Instrucciones Factura"
                                  append-icon="receipt"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary darken-1" @click="tab = 'tab-4'">
                      <v-icon dark> mdi-arrow-left-thick </v-icon> Anterior
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      color="blue-grey darken-2"
                      dark
                      @click="saveGuia()"
                    >
                      Guardar <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item-->
        </v-tabs>
      </v-row>
    </div>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from '../components/Waiting.vue';
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
    codtipoguia: {
      type: String,
      default: "",
    },
  },
  components:{
    Waiting,
  },
  data() {
    return {
      datos: [],
      enableNumGuia: false,
      asignarCliente: false,
      isCliente: false,
      clientes: [],
      cliente: [],
      overlay: false,
      tab: "tab-1",
      validPaq: true,
      validFac: true,
      validRemCon: true,
      validInfoEnv: true,
      validNumRegE: true,
      validNumRegC: true,
      validReferenciasFac: true,
      remConValidos: false,
      infoEnvValidos: false,
      infoPaquetesValidos: false,
      validItemReference: true,
      editando: false,
      direcciones: [],
      direccionesR: [],
      direccionesC: [],
      searchR: null,
      searchC: null,
      dirRemitente: null,
      dirConsignatario: null,
      paises: [],
      estados: [],
      estadoRemitente: null,
      estadoConsignatario: null,
      paisRemitente: null,
      paisConsignatario: null,
      paisOrigenItem: null,
      paisRegNumE: null,
      paisRegNumC: null,
      provincias: [],
      provincia_e: null,
      provincia_c: null,
      ciudadesE: [],
      ciudadesC: [],
      ciudad_e: null,
      ciudad_c: null,
      monedas: [],
      moneda: null,
      terminos: [],
      termino: { value: "DAP", text: "DAP - Delivered at Place" },
      unidades: [],
      unidad: null,
      chkDatosCliente: false,
      chkDatosClienteI: false,
      chkCrearRemitente: false,
      chkCrearConsignatario: false,
      referenciaRemCrear: null,
      referenciaConCrear: null,
      tipo: null,
      tipos: [{ tipo: "Documentos" }, { tipo: "No Documento" }],
      servicio: null,
      servicios: [
        {
          servicio: "Express Worldwide",
          descripcion: "Express Worldwide",
        },
      ],
      seguro: { seguro: "NO" },
      seguros: [{ seguro: "SI" }, { seguro: "NO" }],
      opDDP: { opcion: "No" },
      optsDDP: [{ opcion: "Si" }, { opcion: "No" }],
      facturaPropia: { opcion: "Crear" },
      optFacturaPropia: [{ opcion: "Crear" }],
      boolDocumentos: false, // Si son documentos o no
      readOnlyPorExport: false, // Si el campo es ReadOnly cuando es Export
      optUnidadPesoPaq: [
        { unidad_peso: "kgs", descripcion: "Kilogramos" },
        { unidad_peso: "lbs", descripcion: "Libras" }
        ],
      unidadPesoPaq: { unidad_peso: "kgs", descripcion: "Kilogramos" },
      optUMPaq: [
        { unidad_medida: "cm", descripcion: "Centimetros" },
        { unidad_medida: "in", descripcion: "Pulgadas" }
        ],
      uMPaq: { unidad_medida: "cm", descripcion: "Centimetros" },
      paquete: {
        piezas: 1,
        peso: null,
        unidad_peso: "kgs",
        // embalaje: null,
        largo: 0,
        ancho: 0,
        alto: 0,
        unidad_medida: "cm",
        pesototal: 0,
        volumentotal: 0,
        guia_interna: null,
      },
      headersPaquetes: [
        { text: "Piezas", value: "piezas", align: "start" },
        { text: "Peso", value: "peso" },
        { text: "Unidad Peso", value: "unidad_peso" },
        { text: "Largo", value: "largo" },
        { text: "Ancho", value: "ancho" },
        { text: "Alto", value: "alto" },
        { text: "Unidad Medida", value: "unidad_medida" },
        { text: "Peso Total", value: "pesototal" },
        { text: "Volumen Total", value: "volumentotal" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      headersRegNumbersE: [
        { text: "Código", value: "codigo", align: "start" },
        { text: "Número", value: "numero" },
        { text: "País", value: "pais" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      headersRegNumbersC: [
        { text: "Código", value: "codigo", align: "start" },
        { text: "Número", value: "numero" },
        { text: "País", value: "pais" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      headersInvoiceReferences: [
        { text: "Tipo", value: "tipo", align: "start" },
        { text: "Número", value: "numero" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      paquetes: [],
      itemFac: {
        descripcion: null,
        unidad: null,
        cantidad: null,
        costo: null,
        total: 0,
        peso_neto: null,
        peso_bruto: null,
        pasifab: null,
        arancel: null,
        detalleref: [],
      },
      headersItemsFac: [
        { text: "Descripción", value: "descripcion", align: "start" },
        { text: "UM", value: "unidad" },
        { text: "Cantidad", value: "cantidad" },
        { text: "Costo", value: "costo" },
        { text: "Total", value: "total" },
        { text: "PN", value: "peso_neto" },
        { text: "PB", value: "peso_bruto" },
        { text: "Pais", value: "paisfab" },
        { text: "Arancel", value: "arancel" },
        { text: "Referencias", value: "detalleref" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      itemsFac: [],
      itemReference: {
        tipo: null,
        numero: null,
      },
      // itemReferences: [],
      regNumGuiaE: {
        guia_interna: null,
        cat: "E",
        codigo: null,
        numero: null,
        pais: null,
      },
      regNumGuiaC: {
        guia_interna: null,
        cat: "C",
        codigo: null,
        numero: null,
        pais: null,
      },
      regNumbersGuiaE: [],
      regNumbersGuiaC: [],
      invReferenceTypes: [],
      invReferenceType: null,
      // Invoice References
      invoiceReference: {
        id_guia: null,
        tipo: null,
        numero: null,
      },
      invoiceReferences: [],
      headersItemReferences: [
        { text: "Tipo", value: "tipo", align: "start" },
        { text: "Numero", value: "numero" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      referenceTypes: [],
      referenceType: null,
      registrationNumbers: [],
      regNumberE: null,
      regNumberC: null,
      camposBD: {
        id: null,
        cuenta: null,
        referencia_e: null,
        contacto_e: null,
        empresa_e: null,
        nit_e: null,
        telefono_e: null,
        direccion1_e: null,
        direccion2_e: null,
        direccion3_e: null,
        correo_e: null,
        ciudad_e: null,
        provincia_e: null,
        estado_e: null,
        zip_e: null,
        pais_e: null,
        referencia_c: null,
        contacto_c: null,
        empresa_c: null,
        nit_c: null,
        telefono_c: null,
        direccion1_c: null,
        direccion2_c: null,
        direccion3_c: null,
        correo_c: null,
        ciudad_c: null,
        provincia_c: null,
        estado_c: null,
        zip_c: null,
        pais_c: null,
        rutaorig: null,
        rutadest: null,
        tipo: null,
        descripcion: null,
        valor: 0,
        moneda: null,
        termino: null,
        po: null,
        servicio: null,
        seguro: "NO",
        seg_valor_contenido: null,
        seg_flete_int: null,
        pago: "No",
        /** Campos calculados */
        peso: 0,
        peso_cobrar: 0,
        volumen: 0,
        piezas: 0,
        /** Campos calculados */
        unidad_m: null,
        embalaje: null,
        dimensiones: null,
        unidad_dim: null,
        guia_interna: null,
        proveedor: null,
        guia_proveedor: null,
        fecha_proveedor: null,
        id_usuario: null,
        factura: "Crear",
        recolecta: false,
        tipoguia: null,
        recolectaprov: false,
        numrecolecta: null,
        podfecha: null,
        podhora: null,
        podnombre: null,
        observaciones: null,
        finalizado: false,
        numfactura: null,
        lugarincoterms: null,
        razon_exp: null,
        id_exportador: null,
        cod_exportador: null,
        comentarios_fact: null,
        instrucciones_fact: null,
        detitems: [],
        detpiezas: [],
        numrege: [],
        numregc: [],
        reffac: [],
      },
    };
  },
  watch: {
    dirRemitente: function (item) {
      if (item) {
        this.camposBD.referencia_e = item.referencia;
      }
    },
    dirConsignatario: function (item) {
      if (item) {
        this.camposBD.referencia_c = item.referencia;
      }
    },
    opDDP: function (item) {
      if (item) {
        this.camposBD.pago = item.opcion;
      }
    },
    seguro: function (item) {
      if (item) {
        this.camposBD.seguro = item.seguro;
      }
    },
    servicio: function (item) {
      if (item) {
        this.camposBD.servicio = item.servicio;
      }
    },
    paisRemitente: function (item) {
      if (item) {
        this.camposBD.pais_e = item.iso;
        if (item.iso != "US") {
          this.camposBD.estado_e = null;
          this.estadoRemitente = null;
        }
        if(item.iso != 'EC') {
          this.provincia_e = null;
          this.ciudad_e = null;
          this.camposBD.provincia_e = null;
        }
      }
    },
    estadoRemitente: function (item) {
      if (item) {
        this.camposBD.estado_e = item.abbr;
      }
    },
    cliente: function (item){
      if(item){
        this.camposBD.cuenta = item.codigo;
        this.camposBD.id_usuario = item.id;
      }
    },
    paisConsignatario: function (item) {
      if (item) {
        this.camposBD.pais_c = item.iso;
        if (item.iso != "US") {
          this.camposBD.estado_c = null;
          this.camposBD.estadoConsignatario = null;
        }
        if(item.iso != 'EC') {
          this.provincia_c = null;
          this.ciudad_c = null;
          this.camposBD.provincia_c = null;
        }
      }
    },
    paisOrigenItem: function (item) {
      if (item) {
        this.itemFac.paisfab = item.iso;
      }
    },
    unidad: function (item) {
      if (item) {
        this.itemFac.unidad = item.unidad;
      }
    },
    estadoConsignatario: function (item) {
      if (item) {
        this.camposBD.estado_c = item.abbr;
      }
    },
    tipo: function (item) {
      if (item) {
        this.camposBD.tipo = item.tipo;
      }
    },
    moneda: function (item) {
      if (item) {
        this.camposBD.moneda = item.moneda;
      }
    },
    termino: function (item) {
      if (item) {
        this.camposBD.termino = item.value;
      }
    },
    unidadPesoPaq: function (item) {
      if (item) {
        this.paquete.unidad_peso = item.unidad_peso;
        this.camposBD.unidad_m = item.unidad_peso;
      }
    },
    uMPaq: function (item) {
      if (item) {
        this.paquete.unidad_medida = item.unidad_medida;
      }
    },
    referenceType: function (item) {
      if (item) {
        this.itemReference.tipo = item.codigo;
      }
    },
    invReferenceType: function (item) {
      if (item) {
        this.invoiceReference.tipo = item.codigo;
      }
    },
    facturaPropia: function (item) {
      if (item) {
        this.camposBD.factura = item.opcion;
      }
    },
    regNumberE: function (item) {
      if (item) {
        this.regNumGuiaE.codigo = item.codigo;
      }
    },
    regNumberC: function (item) {
      if (item) {
        this.regNumGuiaC.codigo = item.codigo;
      }
    },
    paisRegNumE: function (item) {
      if (item) {
        this.regNumGuiaE.pais = item.iso;
      }
    },
    paisRegNumC: function (item) {
      if (item) {
        this.regNumGuiaC.pais = item.iso;
      }
    },
    provincia_e: function(item){
       if (item) {
        this.camposBD.provincia_e = item.provincia;
        this.ciudad_e = null;
        this.fillCiudadesE(item.provincia);
      }
    },
    provincia_c: function(item){
       if (item) {
        this.camposBD.provincia_c = item.provincia;
        this.ciudad_c = null;
        this.fillCiudadesC(item.provincia);
      }
    },
    ciudad_e: function(item){
      if(item){
        this.camposBD.ciudad_e = item.ciudad;
        this.camposBD.rutaorig = item.nomenclatura;
        //this.setRutaOrig(item.ciudad);
      }
    },
    ciudad_c: function(item){
      if(item){
        this.camposBD.ciudad_c = item.ciudad;
        this.camposBD.rutadest = item.nomenclatura;
        //this.setRutaDest(item.ciudad);
      }
    },
    searchR(val) {
      val && val !== this.dirRemitente && this.fillLibretasR(val);
    },
    searchC(val) {
      val && val !== this.dirConsignatario && this.fillLibretasC(val);
    },
  },
  created: function () {},
  mounted: async function () {
    this.overlay = true;
    apicon.setAuthHeaders();
    await this.fillLibretas();
    await this.fillClientes();
    await this.fillPaises();
    await this.fillEstados();
    await this.fillMonedas();
    await this.fillTerminos();
    await this.fillUnidades();
    await this.fillReferenceTypes();
    await this.fillInvReferenceTypes();
    await this.fillRegistrationNumbers();
    await this.setCodTipoGuia();
    await this.fillProvincias();
    // Verificar si se han seteado datos
    if (this.id) {
      await this.setEditGuia();
    }
    this.isCliente = localStorage.getItem("cliente");
    this.overlay = false;
  },
  methods: {
    testFunction: function () {
      console.log(this.camposBD);
    },
    validarRemCon: function () {
      if (this.$refs.formRemCon.validate()) {
        // Aparece el siguiente tab y pasamos a el
        this.remConValidos = true;
        this.tab = "tab-2";
      } else {
        this.remConValidos = false;
        this.$swal(
          "Por favor valide los campos obligatorios antes de continuar"
        );
      }
    },
    validarInfoEnvio: function () {
      if (this.$refs.formInfoEnv.validate()) {
        // Aparece el siguiente tab y pasamos a el
        this.infoEnvValidos = true;
        this.tab = "tab-3";
      } else {
        this.infoEnvValidos = false;
        this.$swal(
          "Por favor valide los campos obligatorios antes de continuar"
        );
      }
    },
    validarInfoPaquetes: function(){
      if(this.paquetes.length > 0){
        this.infoPaquetesValidos = true;
        this.tab = "tab-4";
      }else{
        this.infoPaquetesValidos = false;
        this.$swal(
          "Por favor ingrese por lo menos un paquete!"
        );
      }
    },
    calcularPesoTotalPaquete: function () {
      this.paquete.pesototal =
        Math.round(this.paquete.piezas * this.paquete.peso * 100) / 100;
    },
    calcularVolumenTotalPaquete: function () {
      var dim = this.paquete.largo * this.paquete.ancho * this.paquete.alto;
      this.paquete.volumentotal =
        Math.round((dim / 5000) * this.paquete.piezas * 100) / 100;
    },
    calcularCostoTotalItem: function () {
      this.itemFac.total =
        Math.round(this.itemFac.cantidad * this.itemFac.costo * 100) / 100;
    },
    limpiarDatosPaquete: function () {
      this.paquete.piezas = 1;
      this.paquete.peso = null;
      this.paquete.unidad_peso = "kgs";
      this.paquete.largo = 0;
      this.paquete.ancho = 0;
      this.paquete.alto = 0;
      this.paquete.unidad_medida = "cm";
      this.paquete.pesototal = 0;
      this.paquete.volumentotal = 0;
      this.unidadPesoPaq = { unidad_peso: "kgs", descripcion: "Kilogramos" };
      this.uMPaq = { unidad_medida: "cm", descripcion: "Centimetros" };
      this.$refs.piezaspaquete.focus();
    },
    limpiarDatosItemFac: function () {
      this.itemFac.descripcion = null;
      this.itemFac.unidad = null;
      this.itemFac.cantidad = null;
      this.itemFac.costo = null;
      this.itemFac.total = 0;
      this.itemFac.peso_neto = null;
      this.itemFac.peso_bruto = null;
      this.itemFac.pasifab = null;
      this.itemFac.arancel = null;
      this.itemFac.detalleref = [];
      this.unidad = null;
      this.paisOrigenItem = null;
    },
    limpiarDatosItemReference: function () {
      this.itemReference.tipo = null;
      this.itemReference.numero = null;
      this.referenceType = null;
    },
    limpiarDatosRegNumberE: function () {
      this.regNumGuiaE.codigo = null;
      this.regNumGuiaE.numero = null;
      this.regNumGuiaE.pais = null;
      this.regNumberE = null;
      this.paisRegNumE = null;
    },
    limpiarDatosRegNumberC: function () {
      this.regNumGuiaC.codigo = null;
      this.regNumGuiaC.numero = null;
      this.regNumGuiaC.pais = null;
      this.regNumberC = null;
      this.paisRegNumC = null;
    },
    limpiarDatosInvoiceReference: function () {
      this.invoiceReference.tipo = null;
      this.invoiceReference.numero = null;
      this.invReferenceType = null;
    },
    addPaquete: function (paquete) {
      if (this.$refs.formPaquete.validate()) {
        // Verificar si no se esta editando
        if (!this.editando) {
          // Crear una copia del paquete
          const paq = Object.assign({}, paquete);
          this.paquetes.push(paq);
          // Sumar las piezas en camposBD;
          this.limpiarDatosPaquete();
          this.totalizarPesosVolumen();
          this.$refs.formPaquete.resetValidation();
        } else {
          // Si se esta editando guardar en la BD de una sola
          // Agregar la guia interna al paquete
          this.paquete.guia_interna = this.datos.guia_interna;
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "pieza", this.paquete)
            .then(async (result) => {
              if (result.status) {
                this.limpiarDatosPaquete();
                this.$refs.formPaquete.resetValidation();
                await this.fillPiezas();
                this.totalizarPesosVolumen();
              } else {
                this.$swal(result.message);
              }
            });
        }
      }
    },
    addItemFac: function (item) {
      if (this.$refs.formItemFac.validate()) {
        // Verificar si no se esta editando
        if (!this.editando) {
          // Crear una copia del paquete
          item.detalleref = JSON.stringify(item.detalleref);
          const itm = Object.assign({}, item);
          this.itemsFac.push(itm);
          this.limpiarDatosItemFac();
          // this.totalizarPesosVolumen();
          this.$refs.formItemFac.resetValidation();
        } else {
          // Si se esta editando guardar en la BD de una sola
          // Agregar la guia interna al item
          this.itemFac.guia_interna = this.datos.guia_interna;
          this.itemFac.detalleref = JSON.stringify(this.itemFac.detalleref);
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "item", this.itemFac)
            .then((result) => {
              if (result.status) {
                this.limpiarDatosItemFac();
                this.$refs.formItemFac.resetValidation();
                this.fillItems();
              } else {
                this.$swal(result.message);
              }
            });
        }
      }
    },
    addItemReference: function (itemR) {
      if (this.$refs.formItemReference.validate()) {
        // Crear una copia del IR
        const ir = Object.assign({}, itemR);
        this.itemFac.detalleref.push(ir);
        this.limpiarDatosItemReference();
        this.$refs.formItemReference.resetValidation();
      }
    },
    addRegNumberE: function (regNumberE) {
      if (this.$refs.formNumRegE.validate()) {
        // Verificar si no se esta editando
        if (!this.editando) {
          // Crear una copia del RN
          const rn = Object.assign({}, regNumberE);
          this.regNumbersGuiaE.push(rn);
          this.limpiarDatosRegNumberE();
          this.$refs.formNumRegE.resetValidation();
        } else {
          // agregar la guia interna
          this.regNumGuiaE.guia_interna = this.datos.guia_interna;
          apicon
            .saveDataApi(
              apicon.getApiBaseUrl() + "guiaregnumber",
              this.regNumGuiaE
            )
            .then((result) => {
              if (result.status) {
                this.limpiarDatosRegNumberE();
                this.$refs.formNumRegE.resetValidation();
                this.fillRegNumbersE();
              } else {
                this.$swal(result.message);
              }
            });
        }
      }
    },
    addRegNumberC: function (regNumberC) {
      if (this.$refs.formNumRegC.validate()) {
        // verificar si esta editando
        if (!this.editando) {
          // Crear una copia del RN
          const rn = Object.assign({}, regNumberC);
          this.regNumbersGuiaC.push(rn);
          this.limpiarDatosRegNumberC();
          this.$refs.formNumRegC.resetValidation();
        } else {
          // agregar la guia interna
          this.regNumGuiaC.guia_interna = this.datos.guia_interna;
          apicon
            .saveDataApi(
              apicon.getApiBaseUrl() + "guiaregnumber",
              this.regNumGuiaC
            )
            .then((result) => {
              if (result.status) {
                this.limpiarDatosRegNumberC();
                this.$refs.formNumRegC.resetValidation();
                this.fillRegNumbersC();
              } else {
                this.$swal(result.message);
              }
            });
        }
      }
    },
    addInvoiceReference: function (invoiceReference) {
      if (this.$refs.formInvoiceReference.validate()) {
        // verificar si esta editando
        if (!this.editando) {
          // Crear una copia del IR
          const ir = Object.assign({}, invoiceReference);
          this.invoiceReferences.push(ir);
          this.limpiarDatosInvoiceReference();
          this.$refs.formInvoiceReference.resetValidation();
        } else {
          // agregar la id de la guia
          this.invoiceReference.id_guia = this.datos.id;
          apicon
            .saveDataApi(
              apicon.getApiBaseUrl() + "invoicereference",
              this.invoiceReference
            )
            .then((result) => {
              if (result.status) {
                this.limpiarDatosInvoiceReference();
                this.$refs.formInvoiceReference.resetValidation();
                this.fillInvoiceReferences();
              } else {
                this.$swal(result.message);
              }
            });
        }
      }
    },
    deletePaquete: function (paquete) {
      // verificar si se esta editando()
      if (!this.editando) {
        this.paquetes.splice(
          this.paquetes.findIndex((p) => p === paquete),
          1
        );
        this.totalizarPesosVolumen();
      } else {
        apicon
          .deleteDataApi(apicon.getApiBaseUrl() + "pieza/" + paquete.id)
          .then(async () => {
            await this.fillPiezas();
            this.totalizarPesosVolumen();
          });
      }
    },
    deleteItemFac: function (item) {
      // verificar si se esta editando()
      if (!this.editando) {
        this.itemsFac.splice(
          this.itemsFac.findIndex((p) => p === item),
          1
        );
      } else {
        apicon.deleteDataApi(apicon.getApiBaseUrl() + "item/" + item.id).then(
          () => {
            this.fillItems();
          }
        );
      }
    },
    deleteItemReference: function (item) {
      this.itemFac.detalleref.splice(
        this.itemFac.detalleref.findIndex((p) => p === item),
        1
      );
    },
    deleteRegNumberE: function (item) {
      // verificar si se esta editando()
      if (!this.editando) {
        this.regNumbersGuiaE.splice(
          this.regNumbersGuiaE.findIndex((p) => p === item),
          1
        );
      } else {
        this.deleteDataApi(
          apicon.getApiBaseUrl() + "guiaregnumber/" + item.id
        ).then(() => {
          this.fillRegNumbersE();
        });
      }
    },
    deleteRegNumberC: function (item) {
      // verificar si se esta editando()
      if (!this.editando) {
        this.regNumbersGuiaC.splice(
          this.regNumbersGuiaC.findIndex((p) => p === item),
          1
        );
      } else {
        this.deleteDataApi(
          apicon.getApiBaseUrl() + "guiaregnumber/" + item.id
        ).then(() => {
          this.fillRegNumbersC();
        });
      }
    },
    deleteInvoiceReference: function (item) {
      // verificar si se esta editando()
      if (!this.editando) {
        this.invoiceReferences.splice(
          this.invoiceReferences.findIndex((p) => p === item),
          1
        );
      } else {
        this.deleteDataApi(
          apicon.getApiBaseUrl() + "invoicereference/" + item.id
        ).then(() => {
          this.fillInvoiceReferences();
        });
      }
    },
    fillPiezas: async function () {
      await apicon
        .getDataApi(
          apicon.getApiBaseUrl() + "piezas/" + this.camposBD.guia_interna
        )
        .then((result) => {
          this.paquetes = result;
        });
    },
    fillItems: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() + "items/" + this.camposBD.guia_interna
        )
        .then((result) => {
          this.itemsFac = result;
        });
    },
    fillRegNumbersE: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "guiaregnumberse/" +
            this.camposBD.guia_interna
        )
        .then((result) => {
          this.regNumbersGuiaE = result;
        });
    },
    fillRegNumbersC: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "guiaregnumbersc/" +
            this.camposBD.guia_interna
        )
        .then((result) => {
          this.regNumbersGuiaC = result;
        });
    },
    fillInvoiceReferences: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() + "invoicereferences/" + this.camposBD.id
        )
        .then((result) => {
          this.invoiceReferences = result;
        });
    },
    totalizarPesosVolumen: function () {
      this.camposBD.piezas = this.paquetes.reduce(
        (sumPiezas, item) => sumPiezas + parseFloat(item.piezas),
        0
      );
      this.camposBD.peso =
        Math.round(
          this.paquetes.reduce(
            (sumP, item) => sumP + parseFloat(item.pesototal),
            0
          ) * 100
        ) / 100;
      this.camposBD.volumen =
        Math.round(
          this.paquetes.reduce(
            (sumV, item) => sumV + parseFloat(item.volumentotal),
            0
          ) * 100
        ) / 100;
      // Validar el peso a cobrar
      if (this.camposBD.peso > this.camposBD.volumen) {
        if (this.camposBD.peso > Math.round(this.camposBD.peso)) {
          this.camposBD.peso_cobrar = Math.round(this.camposBD.peso) + 0.5;
        } else {
          this.camposBD.peso_cobrar = Math.round(this.camposBD.peso);
        }
      } else {
        if (this.camposBD.volumen > Math.round(this.camposBD.volumen)) {
          this.camposBD.peso_cobrar = Math.round(this.camposBD.volumen) + 0.5;
        } else {
          this.camposBD.peso_cobrar = Math.round(this.camposBD.volumen);
        }
      }
    },
    changeDDP: function () {
      if (this.opDDP.opcion == "Si") {
        this.camposBD.termino = "DDP";
      } else if (this.opDDP.opcion == "No") {
        this.camposBD.termino = "DDU";
      }
    },
    // Metodo para definir acciones segun el codtipoguia
    setCodTipoGuia:async function () {
      //Dejar por defecto siempre moneda USD
      this.moneda = { id: "153", moneda: "USD", nombre: "US Dollar" };
      this.camposBD.moneda = "USD";
      // Si es exportacion
      if (this.codtipoguia == "E") {
        // EL termino por defecto es DDP
        // this.termino = {id:"8", termino:"DDP",descripcion:"Delivered Duty Paid"};
        this.camposBD.tipoguia = "exportacion";
        this.readOnlyPorExport = true;
      } else if (this.codtipoguia == "I") {
        this.camposBD.tipoguia = "importacion";
        this.termino = {
          value: "DAP",
          text: "DAP - Delivered at Place",
        };
        // Dejar el termino DAP por defecto
      } else if (this.codtipoguia == "N") {
        this.camposBD.tipoguia = "nacional";
        this.paisRemitente = this.paises.find((p) => p.iso === "EC");
        console.log(this.paisRemitente);
        this.camposBD.pais_e = "EC";
        this.setServiciosNacionales();
      }
    },
    changeTipo: function () {
      if (this.tipo.tipo == "Documentos") {
        this.boolDocumentos = true;
      } else if (this.tipo.tipo == "No Documento") {
        this.boolDocumentos = false;
      }
    },
    fillLibretas:async function () {
      /*var url = apicon.getApiBaseUrl() + "libretaguia";
      await apicon.getDataApi(url).then((result) => {
        this.direcciones = result;
      });*/
    },
    fillLibretasR: async function(v){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'libreta?search=' + v + '&per_page=50').then((result) => {
        this.direccionesR = result.data;
      });
    },
    fillLibretasC: async function(v){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'libreta?search=' + v + '&per_page=50').then((result) => {
        this.direccionesC = result.data;
      });
    },
    fillClientes: async function(){
      var url = apicon.getApiBaseUrl() + "usuario";
      await apicon.getDataApi(url).then((result) => {
        this.clientes = result;
      });
    },
    fillPaises:async function () {
      var url = apicon.getApiBaseUrl() + "pais";
      await apicon.getDataApi(url).then((result) => {
        this.paises = result;
      });
    },
    fillEstados: function () {
      var url = apicon.getApiBaseUrl() + "estado";
      apicon.getDataApi(url).then((result) => {
        this.estados = result;
      });
    },
    fillProvincias: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "provinciasec")
        .then((result) => {
          this.provincias = result;
        });
    },
    fillCiudadesE:async function (provincia) {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "ciudadesec/" + provincia)
        .then((result) => {
          this.ciudadesE = result;
        });
    },
    fillCiudadesC:async function (provincia) {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "ciudadesec/" + provincia)
        .then((result) => {
          this.ciudadesC = result;
        });
    },
    fillMonedas: function () {
      var url = apicon.getApiBaseUrl() + "moneda";
      apicon.getDataApi(url).then((result) => {
        this.monedas = result;
      });
    },
    fillTerminos: function () {
      var url = apicon.getApiBaseUrl() + "termino";
      apicon.getDataApi(url).then((result) => {
        this.terminos = result;
      });
    },
    fillUnidades: function () {
      var url = apicon.getApiBaseUrl() + "unidad";
      apicon.getDataApi(url).then((result) => {
        this.unidades = result;
      });
    },
    fillReferenceTypes: function () {
      var url = apicon.getApiBaseUrl() + "referencetype";
      apicon.getDataApi(url).then((result) => {
        this.referenceTypes = result;
      });
    },
    fillInvReferenceTypes: function () {
      var url = apicon.getApiBaseUrl() + "invoicereferencetype";
      apicon.getDataApi(url).then((result) => {
        this.invReferenceTypes = result;
      });
    },
    fillRegistrationNumbers: function () {
      var url = apicon.getApiBaseUrl() + "registrationnumber";
      apicon.getDataApi(url).then((result) => {
        this.registrationNumbers = result;
      });
    },
    popularRemitente:async function (item) {
      if (item) {
        this.camposBD.contacto_e = item.contacto;
        this.camposBD.empresa_e = item.empresa;
        this.camposBD.telefono_e = item.telefono;
        this.camposBD.nit_e = item.nit;
        this.camposBD.direccion1_e = item.direccion1;
        this.camposBD.direccion2_e = item.direccion2;
        this.camposBD.direccion3_e = item.direccion3;
        this.camposBD.correo_e = item.correo;
        this.paisRemitente = item.pais_data;
        this.camposBD.pais_e = item.pais_data.iso;
        this.camposBD.ciudad_e = item.ciudad;
        this.estadoRemitente = item.estado_data;
        this.provincia_e = this.provincias.find((pro) => pro.provincia === item.provincia);
        await this.fillCiudadesE(this.provincia_e != null ? this.provincia_e.provincia : 0);
        this.ciudad_e = this.ciudadesE.find((ciu) => ciu.ciudad === item.ciudad);
        this.camposBD.estado_e = item.estado_data != undefined ? item.estado_data.abbr : '';
        this.camposBD.zip_e = item.zip;
      }else{
        this.camposBD.contacto_e = null;
        this.camposBD.empresa_e = null;
        this.camposBD.telefono_e = null;
        this.camposBD.nit_e = null;
        this.camposBD.direccion1_e = null;
        this.camposBD.direccion2_e = null;
        this.camposBD.direccion3_e = null;
        this.camposBD.correo_e = null;
        this.paisRemitente = null;
        this.camposBD.pais_e = null;
        this.camposBD.ciudad_e = null;
        this.estadoRemitente = null;
        this.provincia_e = null;
        //await this.fillCiudadesE(this.provincia_e != null ? this.provincia_e.provincia : 0);
        this.ciudad_e = null;
        this.camposBD.estado_e = null;
        this.camposBD.zip_e = null;
      }
    },
    popularConsignatario: async function (item) {
      if (item) {
        this.camposBD.contacto_c = item.contacto;
        this.camposBD.empresa_c = item.empresa;
        this.camposBD.telefono_c = item.telefono;
        this.camposBD.nit_c = item.nit;
        this.camposBD.direccion1_c = item.direccion1;
        this.camposBD.direccion2_c = item.direccion2;
        this.camposBD.direccion3_c = item.direccion3;
        this.camposBD.correo_c = item.correo;
        this.paisConsignatario = item.pais_data;
        this.camposBD.pais_c = item.pais_data.iso;
        this.camposBD.ciudad_c = item.ciudad;
        this.estadoConsignatario = item.estado_data;
        this.provincia_c = this.provincias.find((pro) => pro.provincia === item.provincia);
        await this.fillCiudadesC(this.provincia_c != null ? this.provincia_c.provincia : 0);
        this.ciudad_c = this.ciudadesC.find((ciu) => ciu.ciudad === item.ciudad);
        this.camposBD.estado_c = item.estado_data != undefined ? item.estado_data.abbr : '';
        this.camposBD.zip_c = item.zip;
      }
    },
    saveGuia: async function () {
      //Verificar los totales de la factura y el valor declarado
      if((!this.boolDocumentos && this.camposBD.tipoguia != 'nacional') ||
        (!this.boolDocumentos && this.camposBD.tipoguia == 'nacional' && this.camposBD.seguro == 'SI')){
        const totalFacturas = this.itemsFac.reduce((pv,cv) => pv + parseFloat(cv.total), 0);
        if((Math.round((parseFloat(totalFacturas) * 100)) / 100)  != (Math.round(parseFloat(this.camposBD.valor) * 100) / 100) ){
          this.$swal("Los totales de facturas y el valor declarado no coicide");
          return;
        }
      }//Fin de verificacion
      // Asignar los objetos de detitems y detpiezas
      this.camposBD.detitems = JSON.stringify(this.itemsFac);
      this.camposBD.detpiezas = JSON.stringify(this.paquetes);
      this.camposBD.numrege = JSON.stringify(this.regNumbersGuiaE);
      this.camposBD.numregc = JSON.stringify(this.regNumbersGuiaC);
      this.camposBD.reffac = JSON.stringify(this.invoiceReferences);
      // Actualizar
      //Verificar si se han ingresado items y facturas
      if(this.paquetes.length == 0){
        this.$swal("Por favor ingrese los paquetes!");
        return;
      }
      if((this.itemsFac.length == 0 && !this.boolDocumentos && this.camposBD.tipoguia != 'nacional') ||
        (this.itemsFac.length == 0 && !this.boolDocumentos && this.camposBD.tipoguia == 'nacional' && this.camposBD.seguro == 'SI')){
        this.$swal("Por favor ingrese el detalle de la factura");
        return;
      }
      if (this.editando) {
        var url = apicon.getApiBaseUrl() + "guias/" + this.camposBD.id;
        apicon.updateDataApi(url, this.camposBD).then((result) => {
          this.$swal(result.message);
        });
      } else {
        // Guardar
        //Verificar si existe la guia que se esta registrando
        if(this.enableNumGuia){//Si esta activo el campo de ingresar numero de guia
          if(this.camposBD.guia_interna == null){
            this.$swal("Ha seleccionado ingresar el numero de guía manualmente y no lo ha ingresado!");
            return;
          }
          let flag  = await this.verificarGuiaExiste();
          if(flag){
            this.$swal("El numero de guia que ha ingresado ya se encuentra registrado");
            return;
          }
        }
        apicon
          .saveDataApi(apicon.getApiBaseUrl() + "guias", this.camposBD)
          .then((result) => {
            if (result.status) {
              this.$swal(result.message);
              this.limpiarCampos();
            } else {
              this.$swal(result.message);
            }
          });
      }
      //Verificar si se actualizaran o guardaran libretas
      let actLibretas = false;
      if(this.chkCrearRemitente && !this.chkDatosCliente){//Primero si se creara/actualizara remitente
        if(this.dirRemitente != null){//Si se ha seleccionado una referencia rem then Actualizar
         await this.updateLibreta('R','U',this.dirRemitente.id);
        }else{//guardar
          await this.updateLibreta('R','S',0);
        }
        actLibretas = true;
      }
      if(this.chkCrearConsignatario){//Primero si se creara/actualizara consig
        if(this.dirConsignatario != null){//Si se ha seleccionado una referencia con then Actualizar
          await this.updateLibreta('C','U',this.dirConsignatario.id);
        }else{//guardar
          await this.updateLibreta('C','S',0);
        }
        actLibretas = true;
      }
      if(actLibretas){
        this.overlay = true;
        await this.fillLibretas();
        this.overlay = false;
      }
    },
    //Guardar o actualizar la libreta
    updateLibreta: async function(remcon,saveupdate,id){
      let datos = {
        referencia: saveupdate == 'U' ? (remcon == 'R' ? this.dirRemitente.referencia : this.dirConsignatario.referencia) : (remcon == 'R' ? this.referenciaRemCrear : this.referenciaConCrear),
        contacto: remcon == 'R' ? this.camposBD.contacto_e : this.camposBD.contacto_c,
        empresa: remcon == 'R' ? this.camposBD.empresa_e : this.camposBD.empresa_c,
        nit: remcon == 'R' ? this.camposBD.nit_e : this.camposBD.nit_c,
        telefono: remcon == 'R' ? this.camposBD.telefono_e : this.camposBD.telefono_c,
        direccion1: remcon == 'R' ? this.camposBD.direccion1_e : this.camposBD.direccion1_c,
        direccion2: remcon == 'R' ? this.camposBD.direccion2_e : this.camposBD.direccion2_c,
        direccion3: remcon == 'R' ? this.camposBD.direccion3_e : this.camposBD.direccion3_c,
        correo: remcon == 'R' ? this.camposBD.correo_e : this.camposBD.correo_c,
        ciudad: remcon == 'R' ? this.camposBD.ciudad_e : this.camposBD.ciudad_c,
        provincia: remcon == 'R' ? this.camposBD.provincia_e : this.camposBD.provincia_c,
        estado: remcon == 'R' ? this.camposBD.estado_e : this.camposBD.estado_c,
        zip: remcon == 'R' ? this.camposBD.zip_e : this.camposBD.zip_c,
        pais: remcon == 'R' ? this.camposBD.pais_e : this.camposBD.pais_c,
      }
      //Guardar o actualizar
      if(saveupdate == 'S'){
        await apicon.saveDataApi(apicon.getApiBaseUrl() + 'libreta',datos).then((result) =>{
          console.log(result);
        });
      }else if(saveupdate == 'U'){
        await apicon.updateDataApi(apicon.getApiBaseUrl() + 'libreta/' + id, datos).then((result) => {
          console.log(result);
        });
      }
    },
    limpiarCampos: async function () {
      this.tab = "tab-1";
      this.dirRemitente = null;
      this.dirConsignatario = null;
      this.paisRemitente = null;
      this.paisConsignatario = null;
      this.estadoRemitente = null;
      this.estadoConsignatario = null;
      this.$refs.formRemCon.resetValidation();
      this.tipo = null;
      this.servicio = null;
      this.seguro = { seguro: "NO" };
      this.opDDP = {opcion : "No"};
      this.$refs.formInfoEnv.resetValidation();
      this.paquetes = [];
      this.itemsFac = [];
      this.facturaPropia = { opcion: "Crear" };
      this.remConValidos = false;
      this.infoEnvValidos = false;
      this.infoPaquetesValidos = false;
      this.regNumbersGuiaE = [];
      this.regNumbersGuiaC = [];
      this.invoiceReferences = [];
      //wait this.resetCampos();
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      this.camposBD.valor = 0;
      await this.setCodTipoGuia();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      //Moneda
      this.moneda = { id: "153", moneda: "USD", nombre: "US Dollar" };
      this.camposBD.moneda = "USD";
      this.asignarCliente = false;
      this.cliente = null;
      console.log(this.codtipoguia);
    },
    setEditGuia: async function () {
      this.editando = true;
      //* ****************Tratar de obtener los datos desde el server y no de la tabla
      this.overlay = true;
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guias/" + this.id)
        .then((result) => {
          this.datos = result;
          this.overlay = false;
        });
      //* ****************Tratar de obtener los datos desde el server y no de la tabla
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = this.datos[key];
      });
      // this.dirRemitente = this.datos.remitente_data;
      this.paisRemitente = this.datos.paisr;
      this.paisConsignatario = this.datos.paisc;
      this.estadoRemitente = this.datos.estador;
      this.estadoConsignatario = this.datos.estadoc;
      this.provincia_c = this.provincias.find((pro) => pro.provincia === this.datos.provincia_c);
      await this.fillCiudadesC(this.provincia_c != null ? this.provincia_c.provincia : 0);
      this.ciudad_c = this.ciudadesC.find((ciu) => ciu.ciudad === this.datos.ciudad_c);
      this.provincia_e = this.provincias.find((pro) => pro.provincia === this.datos.provincia_e);
      await this.fillCiudadesE(this.provincia_e != null ? this.provincia_e.provincia : 0);
      this.ciudad_e = this.ciudadesE.find((ciu) => ciu.ciudad === this.datos.ciudad_e);
      //el termino
      this.termino = this.terminos.find((ter) => ter.value === this.datos.termino);
      // Asignar el tipo
      if (this.datos.tipo == "No Documento") {
        this.tipo = { tipo: "No Documento" };
      } else {
        this.tipo = { tipo: "Documentos" };
      }
      this.changeTipo();
      // asignar la moneda
      this.moneda = this.datos.monedaobj;
      // Asignar el servicio................OJOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO
      this.servicio = this.servicios.find((serv) => serv.servicio === this.datos.servicio);
      // Asignar el seguro
      if (this.datos.seguro == "SI") {
        this.seguro = { seguro: "SI" };
      } else {
        this.seguro = { seguro: "NO" };
      }
      if(this.datos.pago == "Si"){
        this.opDDP = {opcion : "Si"};
      }else{
        this.opDDP = {opcion : "No"};
      }
      this.remConValidos = true;
      this.infoEnvValidos = true;
      this.infoPaquetesValidos = true;
      // Setear la factura propia o crear
      if (this.datos.factura == "Propia") {
        this.facturaPropia = { opcion: "Crear" };
      } else {
        this.facturaPropia = { opcion: "Crear" };
      }
      // Mostrar datos de paquetes e items Items
      this.paquetes = this.datos.paquetes;
      this.itemsFac = this.datos.items;
      // Rellenar los numeros de registro de embarcador y consignatario
      this.fillRegNumbersE();
      this.fillRegNumbersC();
      this.fillInvoiceReferences();
    },
    handleEnableNumGuia: function () {
      if (!this.enableNumGuia) {
        this.camposBD.guia_interna = null;
      }
    },
    handleAsignarCliente: function(){
      if (!this.asignarCliente) {
        this.camposBD.cuenta = null;
        this.camposBD.id_usuario = null;
      }
    },
    verificarGuiaExiste:async function(){
      let flag = false;
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'verificarguiaexiste/' + this.camposBD.guia_interna).then((result) => {
        if(result.status){
          flag = true;
        }
      });
      return flag;
    },
    setServiciosNacionales: function(){
      this.servicios = [];
      this.servicios.push(
        {servicio: "Valija Nacional", descripcion: "Valija Nacional"},
        {servicio: "Valija Local", descripcion: "Valija Local"},
        {servicio: "Valija Interna", descripcion: "Valija Interna"}
      );
    },
    handleChkDatosCliente:async function(){
      if(this.chkDatosCliente){
        this.dirRemitente = null;
        this.camposBD.referencia_e = null;
        this.popularRemitente(null);
        await this.getDatosCliente('R');
      }else{
        this.popularRemitente(null);
      }
    },
    handleChkDatosClienteI:async function(){
      if(this.chkDatosClienteI){
        this.dirConsignatario = null;
        this.camposBD.referencia_c = null;
        this.popularConsignatario(null);
        await this.getDatosCliente('C');
      }else{
        this.popularConsignatario(null);
      }
    },
    getDatosCliente:async function(rc){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'usuario/' + localStorage.getItem("userid"))
            .then(async (result) => {
              if(result){
                if(rc == 'R'){
                  this.camposBD.contacto_e = result.contacto;
                  this.camposBD.empresa_e = result.empresa;
                  this.camposBD.telefono_e = result.telefono;
                  this.camposBD.nit_e = result.nit;
                  this.camposBD.direccion1_e = result.direccion1;
                  this.camposBD.direccion2_e = result.direccion2;
                  this.camposBD.direccion3_e = result.direccion3;
                  this.camposBD.correo_e = result.correo;
                  this.paisRemitente = result.pais_data;
                  this.camposBD.pais_e = result.pais_data.iso;
                  this.camposBD.ciudad_e = result.ciudad;
                  this.estadoRemitente = result.estado_data;
                  this.provincia_e = this.provincias.find((pro) => pro.provincia === result.provincia);
                  await this.fillCiudadesE(this.provincia_e != null ? this.provincia_e.provincia : 0);
                  this.ciudad_e = this.ciudadesE.find((ciu) => ciu.ciudad === result.ciudad);
                  this.camposBD.estado_e = result.estado_data != undefined ? result.estado_data.abbr : '';
                  this.camposBD.zip_e = result.zip;
                }else if(rc == 'C'){
                  this.camposBD.contacto_c = result.contacto;
                  this.camposBD.empresa_c = result.empresa;
                  this.camposBD.telefono_c = result.telefono;
                  this.camposBD.nit_c = result.nit;
                  this.camposBD.direccion1_c = result.direccion1;
                  this.camposBD.direccion2_c = result.direccion2;
                  this.camposBD.direccion3_c = result.direccion3;
                  this.camposBD.correo_c = result.correo;
                  this.paisConsignatario = result.pais_data;
                  this.camposBD.pais_c = result.pais_data.iso;
                  this.camposBD.ciudad_c = result.ciudad;
                  this.estadoConsignatario = result.estado_data;
                  this.provincia_c = this.provincias.find((pro) => pro.provincia === result.provincia);
                  await this.fillCiudadesC(this.provincia_c != null ? this.provincia_c.provincia : 0);
                  this.ciudad_c = this.ciudadesC.find((ciu) => ciu.ciudad === result.ciudad);
                  this.camposBD.estado_c = result.estado_data != undefined ? result.estado_data.abbr : '';
                  this.camposBD.zip_c = result.zip;
                }
              }else{
                this.popularRemitente(null);
              }
            });
    },
    /*setRutaOrig: function(ciudad){
      apicon.saveDataApi(apicon.getApiBaseUrl() + 'rutasec',{ciudad: ciudad} ).then((result) => {
        if(result.status){
          this.camposBD.rutaorig = result.data;
        }
      });
    },
    setRutaDest: function(ciudad){
      apicon.getSaveApi(apicon.getApiBaseUrl() + 'rutasec',{ciudad: ciudad}).then((result) => {
        if(result.status){
          this.camposBD.rutadest = result.data;
        }
      });
    }*/
  },
};
</script>
